export function getCurrentDate(): Date {
    return new Date();
}

export function addOffsetToDate(date: Date, offset: number): Date {
    const newDate = new Date(date.getTime());
    newDate.setDate(date.getDate() + offset);
    return newDate;
}
